<div *ngIf="visible" #blockPage tabindex="-1" class="student-block-ui-layer" aria-live="polite" aria-busy="true">
  <div class="block-background"></div>
  <div class="block-container">
    <div class="block-content-container">
      <img class="block-spinner" width="33" height="33" src="assets/images/loader.svg" alt="Loading" />
    </div>
  </div>
</div>
